import { createReducer, on } from "@ngrx/store"
import { SkillsCheckQandAState, initialSkillsCheckQandAState } from "./skills-check-q-and-a.state"
import { SetState } from "./skills-check-q-and-a.action"
import { getState } from "./skills-check-q-and-a.utils"

export const SkillsCheckQandAReducers = createReducer(
	initialSkillsCheckQandAState,

	on(SetState, (state, action): SkillsCheckQandAState => {
			return {
					...state,
					course: action.courseId,
					questionAnswerState: getState(state, action)
			}
	})
)